import { render, staticRenderFns } from "./wbot-icon.vue?vue&type=template&id=72755a8c&scoped=true"
import script from "./wbot-icon.vue?vue&type=script&lang=js"
export * from "./wbot-icon.vue?vue&type=script&lang=js"
import style0 from "./wbot-icon.vue?vue&type=style&index=0&id=72755a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72755a8c",
  null
  
)

export default component.exports